<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { useMouse, useParentElement } from "@vueuse/core";
import { ref, watch } from "vue";

const parentEl = useParentElement();

const extractor = (event) =>
    window.TouchEvent && event instanceof TouchEvent
        ? null
        : [event.offsetX, event.offsetY];

const { x, y } = useMouse({ target: parentEl, type: extractor });
const hasMoved = ref(false);

watch(
    [x, y],
    ([x, y]) => {
        hasMoved.value = x > 0 && y > 0;
    },
    { immediate: true }
);
</script>

<template>
    <slot v-bind="{ x, y, hasMoved }" />
</template>
